import { lazyWithRetry } from '@tools/utils/lazyWithRetry.ts';
import type { ComponentOrMapping, ComponentPage } from '@cfg/pageRoutes.tsx';

export const ExpensesPage = lazyWithRetry(() =>
  import('@erp/expenses/pages/ExpensesPage.tsx'),
);

const expensesNode = {
  component: ExpensesPage,
} satisfies ComponentPage;

const expensesRoutes: ComponentOrMapping = {
  erp: {
    expenses: expensesNode,
  },
};

export default expensesRoutes;
